import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as s } from "../../chunks/tslib.es6.js";
import r from "../../core/Accessor.js";
import { isAborted as t, createAbortError as e, isPromise as o } from "../../core/promiseUtils.js";
import { property as c } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as n } from "../../core/accessorSupport/decorators/subclass.js";

var i = /*#__PURE__*/function (_r) {
  _inherits(i, _r);

  var _super = _createSuper(i);

  function i() {
    var _this;

    _classCallCheck(this, i);

    _this = _super.apply(this, arguments), _this._tasks = new Array(), _this.running = !1;
    return _this;
  }

  _createClass(i, [{
    key: "length",
    get: function get() {
      return this._tasks.length;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.cancelAll();
    }
  }, {
    key: "runTask",
    value: function runTask(s) {
      for (; !s.done && this._process(s);) {
        s.madeProgress();
      }
    }
  }, {
    key: "push",
    value: function push(s, r, t) {
      var _this2 = this;

      return this.running = !0, new Promise(function (e, o) {
        return _this2._tasks.push(new a(e, o, s, r, t));
      });
    }
  }, {
    key: "unshift",
    value: function unshift(s, r, t) {
      var _this3 = this;

      return this.running = !0, new Promise(function (e, o) {
        return _this3._tasks.unshift(new a(e, o, s, r, t));
      });
    }
  }, {
    key: "_process",
    value: function _process(s) {
      if (0 === this._tasks.length) return !1;

      var r = this._tasks.shift();

      try {
        var _c = t(r.signal);

        if (_c && !r.abortCallback) r.reject(e());else {
          var _t = _c ? r.abortCallback(e()) : r.callback(s);

          o(_t) ? _t.then(r.resolve, r.reject) : r.resolve(_t);
        }
      } catch (c) {
        r.reject(c);
      }

      return this.running = this._tasks.length > 0, !0;
    }
  }, {
    key: "cancelAll",
    value: function cancelAll() {
      var s = e();

      var _iterator = _createForOfIteratorHelper(this._tasks),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _r2 = _step.value;

          if (_r2.abortCallback) {
            var _t2 = _r2.abortCallback(s);

            _r2.resolve(_t2);
          } else _r2.reject(s);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this._tasks.length = 0, this.running = !1;
    }
  }]);

  return i;
}(r);

s([c()], i.prototype, "running", void 0), i = s([n("esri.layers.support.PromiseQueue")], i);

var a = function a(s, r, t, e, o) {
  _classCallCheck(this, a);

  this.resolve = s, this.reject = r, this.callback = t, this.signal = e, this.abortCallback = o;
};

export { i as PromiseQueue };